import script from "./SupervisorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupervisorView.vue?vue&type=script&setup=true&lang=ts"

import "./SupervisorView.vue?vue&type=style&index=0&id=38118439&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38118439"]])

export default __exports__